module.exports = __webpack_public_path__ + "img/login-orange.b71c2aee.svg";